import type { UserMentionOutput } from "@orsane/schema/mentions";
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const UserMentionComponent = ({ node }: NodeViewProps) => {
    const { label, email } = node.attrs as UserMentionOutput;

    return (
        <NodeViewWrapper as="span" className="mention mention--user inline-block bg-sky-100 px-0.5 rounded-xs font-medium!">
            <Tooltip>
                <TooltipTrigger delay={300} render={<span>@{label}</span>}></TooltipTrigger>
                {email && (
                    <TooltipContent side="top" className="text-xs">
                        {email}
                    </TooltipContent>
                )}
            </Tooltip>
        </NodeViewWrapper>
    );
};
